import { render } from "./PayPublic.vue?vue&type=template&id=0a56a460&scoped=true"
import script from "./PayPublic.vue?vue&type=script&lang=js"
export * from "./PayPublic.vue?vue&type=script&lang=js"

import "./PayPublic.vue?vue&type=style&index=0&id=0a56a460&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a56a460"]])

export default __exports__